import { Box } from "@material-ui/core";
import { FC, useEffect } from "react";
import { useStyles } from "./styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useDispatch } from "react-redux";
import {
  falconSetDate,
  falconSetStation,
  falconSetType,
  getFalconData,
} from "actions/falconAction";
import { DateFilter } from "componentsNew/elements/DateFilter";
import { FilterSwitch } from "componentsNew/elements/TabSwitch";
import { StationSelect } from "componentsNew/elements/SelectField";

interface PropsType {}

const FalconHead: FC<PropsType> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { falconFilters } = useTypeSelectors((state) => state.falconTable);

  const handleChangeExternalSelectType = (select: string) => dispatch(falconSetType(select));

  const handleChangeWeek = (week: string) => dispatch(falconSetDate({ week }));

  const handleChangeMonth = (month: string) => dispatch(falconSetDate({ month }));

  useEffect(() => {
    const params = {
      stations:  falconFilters?.station === "0" ? null : falconFilters?.station,
      ...(falconFilters.selectType === "month" && {
        month: Number(falconFilters.date.month.split("-")[1]),
        year: Number(falconFilters.date.month.split("-")[0]),
      }),
      ...(falconFilters.selectType === "week" && {
        week: Number(falconFilters.date.week.split("-W")[1]) - 1,
        year: Number(falconFilters.date.week.split("-W")[0]),
      }),
    };
    dispatch(getFalconData(params));
  }, [
    falconFilters.date.week,
    falconFilters.date.month,
    falconFilters?.station,
    falconFilters.selectType,
    dispatch,
  ]);

  return (
    <Box className={classes.paper}>
      <Box className={classes.filters}>
        <Box className={classes.filtersLeft}>
          <StationSelect
            value={falconFilters?.station}
            onChange={(value: string) => dispatch(falconSetStation(value))}
            hasAllOption
          />
          <DateFilter
            type={falconFilters.selectType}
            weekValue={falconFilters.date?.week}
            monthValue={falconFilters.date?.month}
            weekChange={handleChangeWeek}
            monthChange={handleChangeMonth}
            hasSwitch
          />
        </Box>
        <FilterSwitch
          type={falconFilters.selectType}
          enabledFilters={["month", "week"]}
          action={handleChangeExternalSelectType}
        />
      </Box>
    </Box>
  );
};

export default FalconHead;
